import { StyleSheet } from "react-native";
import { appColors } from "../../appTheme";

export const commonDialogBoxStyle = StyleSheet.create({
    conatiner: { flex: 1, justifyContent: 'center', width: '100%' },
    wrapper: { paddingHorizontal: 15, paddingVertical: 15, backgroundColor: appColors.lightBackgroundColor },
    contentTxt: { paddingHorizontal: 20, paddingVertical: 10 },
})
